<template>
  <div class="content">
    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <div class="upload-box">
          <h2 class="upload-titile input-title-hq red-required">车头行驶证正页 <span class="image-show" @click="showImageDemo('ctzbfm')">（示例:如图）</span></h2>
          <div class="upload-xsz-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="ctZbFmImage" 
            :before-read="beforeRead" :after-read="uploadctZbFm" :before-delete="deleteCtZbFm"></van-uploader>
          </div>

          <h2 class="upload-titile input-title-hq red-required">车挂行驶证正页 <span class="image-show" @click="showImageDemo('cgzbfm')">（示例:如图）</span></h2>
          <div class="upload-xsz-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="cgZbFmImage" 
            :before-read="beforeRead" :after-read="uploadcgZbFm" :before-delete="deleteCgZbFm"></van-uploader>
          </div>

          <div class="jsz-front-info-box">
            <van-field v-model="chetouhao" required :rules="[{ required:true, message: '请填写车头号' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">车头号</span>
              </template>
            </van-field>
            <van-field v-model="cheguahao" required :rules="[{ required:true, message: '请填写车头号' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">车挂号</span>
              </template>
            </van-field>
          </div>
        </div>
      </van-cell-group>

      <div style="margin: 1rem;">
        <van-button round block type="info" native-type="submit" class="addBtn" @loading="loadingBtn" color="#316892">
          保存
        </van-button>
      </div>
    </van-form>
    <van-dialog v-model="dialogShow" :message="dialogMessage" 
      show-cancel-button show-confirm-button confirm-button-text="前往新增" @confirm="confirmBind">
    </van-dialog>

    <Tabbar></Tabbar>
  </div>

</template>
<script>
import api from "@/fetch/api"
import { Toast,Dialog,ImagePreview } from 'vant';
import Compressor from 'compressorjs';
import Tabbar from '@/views/Public/tabbarTpl.vue'

export default {
  components: {
    Tabbar
  },
  data(){
    return {
      ctZbFmImage:[],
      cgZbFmImage:[],
      ctZbFmUrl:"",
      cgZbFmUrl:"",
      chetouhao:"",
      cheguahao:"",
      dialogShow:false,
      loadingBtn:false,
      dialogMessage:"",
      bindType:"",
    }
  },
  methods: {
    //上传车头正本反面 正页
    uploadctZbFm(file) {
      this.bindType = "";
      this.dialogShow = false;
      this.chetouhao = "";
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_zb_fm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.ctZbFmUrl = imageData.xingshizhengzbfmurl ? imageData.xingshizhengzbfmurl : "";
          that.ctZbFmImage = imageData.xingshizhengzbfmurl ? [{url: weburl + '/' + imageData.xingshizhengzbfmurl}] : [];

          if (imageData.bpmStatus === "3") {
            var detail = imageData;
            that.mergeinfo(detail);
          } else {
            that.xsz_zb_fm_url = imageData.xingshizhengzbfmurl ? imageData.xingshizhengzbfmurl : "";
            var chetouhao = imageData.chetouhao ? imageData.chetouhao : that.chetouhao; //车头号
            that.chetouhao = chetouhao;
            if(chetouhao){
              //检索车头号信息
              that.searchChetou(chetouhao);
            }
            else{
              that.dialogShow = true;
              that.dialogMessage = "此车号不存在，是否更换车号，仍需绑定该车辆请联系15351952723。";
              that.bindType = "chetou";
            }
          }
        } else {
          that.dialogShow = true;
          that.dialogMessage = "此车号不存在，是否更换车号，仍需绑定该车辆请联系15351952723。";
          that.bindType = "chetou";
        }
      }).catch(function(error) {
      console.log(error);
      });
    },
    //上传行驶证正本反面 正页
    uploadcgZbFm(file) {
      this.bindType = "";
      this.dialogShow = false;
      this.cheguahao = "";
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_zb_fm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadCheguaXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.cgZbFmUrl = imageData.xingshizhengzbfmurl ? imageData.xingshizhengzbfmurl : "";
          that.cgZbFmImage = imageData.xingshizhengzbfmurl ? [{url: weburl + '/' + imageData.xingshizhengzbfmurl}] : [];

          if (imageData.bpmStatus === "3") {
            var detail = imageData;
            that.mergeinfo(detail);
          } else {
            that.xsz_zb_fm_url = imageData.xingshizhengzbfmurl ? imageData.xingshizhengzbfmurl : "";
            var cheguahao = imageData.cheguahao ? imageData.cheguahao : that.cheguahao; //车挂号
            that.cheguahao = cheguahao;
            if(cheguahao){
              //检索车头号信息
              that.searchChegua(cheguahao);
            }
            else{
              that.dialogShow = true;
              that.dialogMessage = "此车号不存在，是否更换车号，仍需绑定该车辆请联系15351952723。";
              that.bindType = "chegua";
            }
          }
        } else {
          that.dialogShow = true;
          that.dialogMessage = "此车号不存在，是否更换车号，仍需绑定该车辆请联系15351952723。";
          that.bindType = "chegua";
        }
      }).catch(function(error) {
        console.log(error);
      });
    },
    searchChetou(search)
    {
      var that = this;
      api.searchChetou(search).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            var chetouItems = res.data;
            if(chetouItems.length<=0){
              that.dialogShow = true;
              that.dialogMessage = "此车号不存在，是否更换车号，仍需绑定该车辆请联系15351952723。";
              that.bindType = "chetou";
            }
          }
        }).catch(function(err) {
          console.log(err);
        });
    },
    searchchegua(search)
    {
      var that = this;
      api.searchChegua(search).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            var cheguaItems = res.data;
            if(cheguaItems.length<=0){
              that.dialogShow = true;
              that.dialogMessage = "此车号不存在，是否更换车号，仍需绑定该车辆请联系15351952723。";
              that.bindType = "chegua";
            }
          }
        }).catch(function(err) {
          console.log(err);
        });
    },
    deleteCtZbFm() {
      this.ctZbFmUrl = "";
      this.ctZbFmImage = [];
    },
    deleteCgZbFm() {
      this.cgZbFmUrl = "";
      this.cgZbFmImage = [];
    },
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });

    },
    //示例图
    showImageDemo(type) {
      let images = [];
      switch (type) {
        case 'ctzbzm':
          images = [require('@/assets/images/ctsl.png')];
          break;
        case 'cgzbzm':
          images = [require('@/assets/images/ctsl.png')];
          break;
      }
      ImagePreview({
        images: images,
        closeable: true,
      });
    },
    onOversize() {
      Toast('文件大小不能超过 10Mb');
    },
    onSubmit()
    {
      var openid = this.$store.state.wx_info.openid;
      var chetouhao = this.chetouhao;
      var cheguahao = this.cheguahao;
      var that = this;
      that.loadingBtn = true;
      api.bindVehicle(openid, chetouhao, cheguahao).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          sessionStorage.removeItem('chetouhao');
          sessionStorage.removeItem('cheguahao');
          that.loadingBtn = false;
          Dialog.alert({
            message: '绑定成功',
          }).then(() => {
            that.$router.push({
              name: 'vehicle'
            });
          });
        } else {
          Dialog.alert({
            message: (res.message && res.message.includes('未查询到可用的用户信息来绑定车辆')) ? '该用户openid不可用' : res.message,
          }).then(() => {

          });
        }
      }).catch(function() {
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');

      });
    },
    confirmBind()
    {
      var bindType = this.bindType;
      switch(bindType)
      {
        case "chetou":
          this.$router.push({
              name: 'addchetou'
            });
          break;
        case "chegua":
          this.$router.push({
              name: 'addchegua'
            });
          break;
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .content {
    margin-top: 1rem;
    margin-bottom: 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
    
    .upload-box {
        background: #fff;
        margin-top: 0.625rem;
        .upload-titile {
            padding: 0.675rem 1rem;
            .image-show {
                margin-left: 0.5rem;
                color: #2440b3;
            }
        }
        .title-extend {
            line-height: 1.5;
        }
        .upload-xsz-box {
            margin-left: 1rem;
        }
    }
  }
</style>
